module.exports = __webpack_public_path__ + "static/img/4en.d1d01f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/4en.png
// module id = UasG
// module chunks = 0